import React from 'react';
import styles from './ModalLayoutBasicFooter.scss';
import { ButtonPriority as PRIORITY, TextButtonPriority as TEXT_BUTTON_PRIORITY } from 'wix-ui-tpa';
import dataHooks from '../../data-hooks';
import { useTranslation } from '@wix/yoshi-flow-editor';
import Button from '../Button';
import Text from '../../core-components/Text';
import classNames from 'classnames';
import { TextButton } from '../TextButton';

export interface ModalLayoutBasicFooterProps {
  onOkClick: () => void;
  onCancelClick?: () => void;
  onSecondaryClick?: () => void;
  isMobile?: boolean;
  centered?: boolean;
  borderTop?: boolean;
  className?: string;
  fullWidthMobile?: boolean;
  isSaveBtnDisabled?: boolean;
  spaceBetween?: boolean;
  showSecondaryButton?: boolean;
  secondaryButtonContent?: React.ReactNode;
  primaryButtonContent?: React.ReactNode;
  cancelButtonContent?: React.ReactNode;
  isLoading?: boolean;
  equalWidthButtons?: boolean;
}

const ModalLayoutBasicFooter: React.FC<ModalLayoutBasicFooterProps> = ({
  onOkClick,
  onCancelClick,
  onSecondaryClick,
  isMobile,
  centered,
  borderTop,
  className = '',
  fullWidthMobile = '',
  isSaveBtnDisabled,
  spaceBetween,
  secondaryButtonContent,
  primaryButtonContent,
  showSecondaryButton,
  cancelButtonContent,
  isLoading,
  equalWidthButtons,
}) => {
  const { t } = useTranslation();
  const cls = classNames({
    [styles.wrapper]: true,
    [className]: Boolean(className),
    [styles.mobile]: isMobile,
    [styles.centered]: centered,
    [styles.borderTop]: borderTop,
    [styles.fullWidthMobile]: fullWidthMobile,
    [styles.spaceBetween]: spaceBetween,
    [styles.equalWidthButtons]: equalWidthButtons,
  });

  return (
    <div className={cls} data-hook="modal-layout-basic-footer">
      {!showSecondaryButton && !secondaryButtonContent && onCancelClick && (
        <Button
          upgrade
          className={styles.button}
          fullWidth={isMobile}
          onClick={() => onCancelClick()}
          priority={PRIORITY.secondary}
          data-hook={dataHooks.dispatchSummaryButtonCancel}
          disabled={isLoading}
        >
          <Text typography="p2-m-colorless">
            {cancelButtonContent ? cancelButtonContent : t('order_settings_modal_button_cancel')}
          </Text>
        </Button>
      )}
      {showSecondaryButton && onSecondaryClick && (
        <TextButton
          priority={TEXT_BUTTON_PRIORITY.link}
          data-hook={dataHooks.modalSecondaryButton}
          onClick={onSecondaryClick}
          disabled={isLoading}
        >
          {secondaryButtonContent}
        </TextButton>
      )}
      <div className={`${styles.spacer} ${isMobile && styles.mobile}`} />
      <Button
        upgrade
        className={styles.button}
        fullWidth={isMobile}
        onClick={() => onOkClick()}
        priority={PRIORITY.primary}
        data-hook={dataHooks.dispatchSummaryButtonOk}
        disabled={isSaveBtnDisabled || isLoading}
        loading={isLoading}
      >
        <Text typography="p2-m-colorless">
          {primaryButtonContent ? primaryButtonContent : t('order_settings_modal_button_save')}
        </Text>
      </Button>
    </div>
  );
};

ModalLayoutBasicFooter.displayName = 'ModalLayoutBasicFooter';

export default ModalLayoutBasicFooter;
